export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapTollingPoints';
